import type { FC } from 'react';

import styles from './TitleWithHighlight.scss';

interface Props {
  title: string;
  partToHighlight: string;
}
export const TitleWithHighlight: FC<Props> = ({ title, partToHighlight }) => {
  const regex = RegExp(`(${partToHighlight})`, 'gi');
  const parts = title.split(regex);

  return (
    <span>
      {parts.map((part, index) =>
        part.toLowerCase() === partToHighlight.toLowerCase() ? (
          <mark key={part + index} className={styles.highlighted}>
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </span>
  );
};
